export default __webpack_public_path__ + "static/media/NewFileUploads.c9622686.svg";